<template>
	<div class="onlinemsg">
<!--		<dd>-->
<!--			<div class="ondiv ondiv_tel">-->
<!--				<i class="iconfont yswl-dianhua3"></i>-->
<!--				<span>电话咨询</span>-->
<!--			</div>-->
<!--			<div class="ondiv_tel_show">-->
<!--				0533-123456789-->
<!--			</div>-->
<!--		</dd>-->
<!--		<dd>-->
<!--			<a href="" target="_blank">-->
<!--				<div class="ondiv">-->
<!--					<i class="iconfont yswl-qq1"></i>-->
<!--					<span>QQ咨询</span>-->
<!--				</div>-->
<!--			</a>-->
<!--		</dd>-->
		<dd>
			<div class="ondiv">
				<i class="iconfont yswl-erweima"></i>
				<span>微信咨询</span>
			</div>
			<div class="ondiv_ewm_show">
				<img src="@/assets/images/xcx.jpg" alt="">
			</div>
		</dd>
		<dd class="dd_backtop">
			<el-backtop>
				<i class="iconfont yswl-xiangshangjiantou"></i>
				<span>TOP</span>
			</el-backtop>
		</dd>
	</div>
</template>

<script>
	export default{
		date(){
			return{
				
			}
		},
		created() {

		},
		methods:{
			
		}
	
	}
</script>

<style scoped>
	.onlinemsg{
		width: 66px;
		position: fixed;
		right: 20px;
		bottom: 20%;
		z-index: 10;
		border: solid 1px #DBDBDB;
		background: #ffffff;
		border-bottom: none;
	}
	.onlinemsg dd{
		background: #ffffff;
		position: relative;
		width: 100%;
		border-top: solid 1px #DADADA;
		cursor: pointer;
		-o-transition: all 0.5s;
		-moz-transition: all 0.5s;
		-ms-transition: all 0.5s;
		-webkit-transition: all 0.5s;
		transition: all 0.5s;
	}
	.ondiv{
		width: 100%;
		display: flex;
		justify-content:center;
		flex-direction:column;
		align-items:center;
		padding: 10px 0;
		z-index: 2;
		position: relative;
	}
	.ondiv i{
		font-size: 22px;
		display: inline-block;
	}
	.ondiv span{
		color: #606060;
		display: inline-block;
		font-size: 14px;
	}
	.ondiv_tel i{
		font-size: 26px;
	}
	
	.onlinemsg dd:hover{
		background: -o-linear-gradient(to right,#FFA060, #FBB88E);
		background: -moz-linear-gradient(to right,#FFA060, #FBB88E);
		background: -ms-linear-gradient(to right,#FFA060, #FBB88E);
		background: -webkit-linear-gradient(to right,#FFA060, #FBB88E);
		background: linear-gradient(to right,#FFA060, #FBB88E);
	}
	.onlinemsg dd:hover .ondiv span{
		color: #ffffff;
	}
	.onlinemsg dd:hover .ondiv i{
		color: #ffffff;
	}
	.ondiv_tel_show{
		position: absolute;
		right: 100%;
		top: 0;
		background: #ffffff;
		font-size: 18px;
		width: 0;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 0 5px #cccccc;
		z-index: -1;
		opacity: 0;
		pointer-events: visible;
		-o-transition: all 0.2s;
		-moz-transition: all 0.2s;
		-ms-transition: all 0.2s;
		-webkit-transition: all 0.2s;
		transition: all 0.2s;
	}
	.onlinemsg dd:hover .ondiv_tel_show{
		opacity: 1;
		pointer-events: auto;
		right: 100%;
		width: 180px;
	}
	.ondiv_ewm_show{
		width: 0;
		height: 100px;
		position: absolute;
		right:100%;
		top: -18px;
		z-index: 1;
		opacity: 0;
		width: 0;
		pointer-events: visible;
		-o-transition: all 0.2s;
		-moz-transition: all 0.2s;
		-ms-transition: all 0.2s;
		-webkit-transition: all 0.2s;
		transition: all 0.2s;
	}
	.ondiv_ewm_show img{
		width: 100%;
	}
	.onlinemsg dd:hover .ondiv_ewm_show{
		width: 100px;
		opacity: 1;
		pointer-events: auto;
		right: 100%;
	}
	.onlinemsg dd:first-child{
		border-top: none;
	}
	.dd_backtop{
		border-bottom: solid 1px #dbdbdb;
	}
	
	.dd_backtop .el-backtop{
		position: relative;
		right: 0 !important;
		bottom: 0 !important;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		width: 100%;
		height: auto;
		border-radius: 0;
		background-color: unset;
		box-shadow: none;
		color: #606060;
		padding: 10px 0 !important;
	}
	.dd_backtop span{
		font-size: 16px;
	}
	.onlinemsg dd:hover .dd_backtop .el-backtop{
		background: -o-linear-gradient(to right,#FFA060, #FBB88E);
		background: -moz-linear-gradient(to right,#FFA060, #FBB88E);
		background: -ms-linear-gradient(to right,#FFA060, #FBB88E);
		background: -webkit-linear-gradient(to right,#FFA060, #FBB88E);
		background: linear-gradient(to right,#FFA060, #FBB88E);
	}
	.onlinemsg .dd_backtop:hover .el-backtop span{
		color: #ffffff !important;
	}
	.onlinemsg .dd_backtop:hover .el-backtop i{
		color: #ffffff !important;
	}
	
</style>